import { types } from '../actions/accessToParts';

const initialState = {
  onboarding: false,
  tAndEContractor: false,
  tAndEApprover: false
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.SET_ALLOWED_PARTS:
      return action.payload;
    default:
      return state;
  }
}
